module.exports = __webpack_public_path__ + "static/media/MVNZ_web_3.7dd2ca11.jpg";